function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 283.5 283.5"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M58.4 244.6l-26.6-10.2L55 173.8l-27.2-64.1 28.9-70.8 26.4 10.7-24.4 59.9 27 63.8zM143.4 244.6l-26.7-10.2 23.2-60.6-27.1-64.1 28.9-70.8 26.4 10.7-24.4 59.9 27 63.8zM228.3 244.6l-26.6-10.2 23.2-60.6-27.1-64.1 28.9-70.8 26.4 10.7-24.4 59.9 26.9 63.8z"
})));